export const PAYROLL_LOADING = "PAYROLL_LOADING";
export const GET_PAYROLL = "GET_PAYROLL";
export const GET_PAYROLL_SUCCESS = "GET_PAYROLL_SUCCESS";
export const GET_PAYROLL_FAIL = "GET_PAYROLL_FAIL";
export const DELETE_PAYROLL = "DELETE_PAYROLL"
export const DELETE_PAYROLL_SUCCESS = "DELETE_PAYROLL_SUCCESS"
export const DELETE_PAYROLL_FAIL = "DELETE_PAYROLL_FAIL"
export const UPDATE_PAYROLL = "UPDATE_PAYROLL"
export const UPDATE_PAYROLL_SUCCESS = "UPDATE_PAYROLL_SUCCESS"
export const UPDATE_PAYROLL_FAIL = "UPDATE_PAYROLL_FAIL"
export const ADD_NEW_PAYROLL = "ADD_NEW_PAYROLL"
export const ADD_PAYROLL_SUCCESS = "ADD_PAYROLL_SUCCESS"
export const ADD_PAYROLL_FAIL = "ADD_PAYROLL_FAIL"